// extracted by mini-css-extract-plugin
module.exports = {"menuLogo":"Navigation_menuLogo__rYLC_","title":"Navigation_title__1f895"};